export const isAbsoluteUrl = (toCheck: string) => {
  return toCheck.startsWith('http://') || toCheck.startsWith('https://');
}